import SubscriptionSummary from "pages/subscription/SubscriptionSummary";
import GeneralSummary from "pages/subscription/GeneralSummary";
import SophiaVoiceAgent from "pages/subscription/SophiaVoiceAgent";
import RuleEngine from "pages/subscription/rule-engine/RuleEngine";
import CurrencyAndCostPage from "pages/subscription/rule-engine/CurrencyAndCost/CurrencyAndCost";
import AutoSaving from "pages/subscription/rule-engine/AutoSaving";
import SalaryDisbursement from "pages/subscription/rule-engine/SalaryDisbursement";
import PayrollVendor from "pages/subscription/rule-engine/PayrollVendor";
import CurrencyConversions from "pages/subscription/rule-engine/CurrencyAndCost/CurrencyConversions";
import AuditTrailPage from "pages/subscription/rule-engine/CurrencyAndCost/AuditTrail";
import BulkImport from "pages/subscription/rule-engine/CurrencyAndCost/BulkImport";
// import other components like CallCreditPurchase, PhoneNumberPurchase etc. if you have them

// Define a structure for each menu item
interface ThirdDropdownConfig {
  label: string;
  options: {
    name: string;
    component: React.ComponentType<any>;
  }[];
}

interface SubscriptionConfig {
  menus: string[]; // just plain labels now
  thirdDropdowns: Record<string, ThirdDropdownConfig>; // keyed by menu name
}

// Main config object
export const subscriptionConfig: Record<string, SubscriptionConfig> = {
  "All Packages": {
    menus: ["Subscription summary", "Rule engine", "Product Update"],
    thirdDropdowns: {
      "Subscription summary": {
        label: "Duration",
        options: [
          { name: "1 month", component: SubscriptionSummary },
          { name: "3 months", component: SubscriptionSummary },
          { name: "All time", component: SubscriptionSummary },
        ],
      },
      "Rule engine": {
        label: "Rule Type",
        options: [
          // { name: "Autosaving", component: AutoSaving },
          { name: "Bulk imports", component: BulkImport },
          { name: "Currency & Cost", component: CurrencyAndCostPage },
          { name: "Currency Conversion", component: CurrencyConversions },
          { name: "Audit Trail", component: AuditTrailPage },
        ],
      },
      "Product Update": {
        label: "Duration",
        options: [
          { name: "1 month", component: SubscriptionSummary },
          { name: "3 months", component: SubscriptionSummary },
        ],
      },
    },
  },
  "Saas seats": {
    menus: ["Subscription summary"],
    thirdDropdowns: {
      "Subscription summary": {
        label: "Duration",
        options: [
          { name: "1 month", component: SubscriptionSummary },
          { name: "3 months", component: SubscriptionSummary },
          { name: "All time", component: SubscriptionSummary },
        ],
      },
    },
  },
  "Sophia voice agent": {
    menus: [
      "General summary",
      "Call credit purchase & use",
      "Phone number purchase",
    ],
    thirdDropdowns: {
      "General summary": {
        label: "Duration",
        options: [
          { name: "1 month", component: GeneralSummary },
          { name: "3 months", component: SophiaVoiceAgent },
          { name: "All time", component: SophiaVoiceAgent },
        ],
      },
      "Call credit purchase & use": {
        label: "Duration",
        options: [
          { name: "1 month", component: SophiaVoiceAgent },
          { name: "3 months", component: SophiaVoiceAgent },
        ],
      },
      "Phone number purchase": {
        label: "Duration",
        options: [
          { name: "1 month", component: SophiaVoiceAgent },
          { name: "3 months", component: SophiaVoiceAgent },
        ],
      },
    },
  },
};
